/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBasicAuthToObject, setBearerAuthToObject, setSearchParams, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * AccountControllerV2Api - axios parameter creator
 * @export
 */
export const AccountControllerV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Internal API endpoint secured by the PRS Basic Auth Credentials. Fetches customer data (including EAV customers) from the CDS or LMS and returns it. The data is only used by the product-review-service. The call to the CDS is secured by another, different set of Basic Auth credentials.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} customerNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageCustomerNumberGet: (tenant_1, language_1, customerNumber_1, ...args_1) => __awaiter(this, [tenant_1, language_1, customerNumber_1, ...args_1], void 0, function* (tenant, language, customerNumber, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV2TenantLanguageCustomerNumberGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('accountV2TenantLanguageCustomerNumberGet', 'language', language);
            // verify required parameter 'customerNumber' is not null or undefined
            assertParamExists('accountV2TenantLanguageCustomerNumberGet', 'customerNumber', customerNumber);
            const localVarPath = `/account/v2/{tenant}/{language}/{customerNumber}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"customerNumber"}}`, encodeURIComponent(String(customerNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Used by a customer to retrieve the last order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageLastOrderGet: (tenant_1, language_1, ...args_1) => __awaiter(this, [tenant_1, language_1, ...args_1], void 0, function* (tenant, language, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV2TenantLanguageLastOrderGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('accountV2TenantLanguageLastOrderGet', 'language', language);
            const localVarPath = `/account/v2/{tenant}/{language}/lastOrder`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Used by the customer to retrieve all its orders.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageOrdersGet: (tenant_1, language_1, page_1, itemsPerPage_1, ...args_1) => __awaiter(this, [tenant_1, language_1, page_1, itemsPerPage_1, ...args_1], void 0, function* (tenant, language, page, itemsPerPage, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV2TenantLanguageOrdersGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('accountV2TenantLanguageOrdersGet', 'language', language);
            const localVarPath = `/account/v2/{tenant}/{language}/orders`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Used by a customer to retrieve a single order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} orderNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageOrdersOrderNumberGet: (tenant_1, language_1, orderNumber_1, ...args_1) => __awaiter(this, [tenant_1, language_1, orderNumber_1, ...args_1], void 0, function* (tenant, language, orderNumber, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV2TenantLanguageOrdersOrderNumberGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('accountV2TenantLanguageOrdersOrderNumberGet', 'language', language);
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('accountV2TenantLanguageOrdersOrderNumberGet', 'orderNumber', orderNumber);
            const localVarPath = `/account/v2/{tenant}/{language}/orders/{orderNumber}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns customer data including EAV customer and RedPointsMembership.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageUserGet: (tenant_1, language_1, ...args_1) => __awaiter(this, [tenant_1, language_1, ...args_1], void 0, function* (tenant, language, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV2TenantLanguageUserGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('accountV2TenantLanguageUserGet', 'language', language);
            const localVarPath = `/account/v2/{tenant}/{language}/user`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AccountControllerV2Api - functional programming interface
 * @export
 */
export const AccountControllerV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountControllerV2ApiAxiosParamCreator(configuration);
    return {
        /**
         * Internal API endpoint secured by the PRS Basic Auth Credentials. Fetches customer data (including EAV customers) from the CDS or LMS and returns it. The data is only used by the product-review-service. The call to the CDS is secured by another, different set of Basic Auth credentials.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} customerNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageCustomerNumberGet(tenant, language, customerNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV2TenantLanguageCustomerNumberGet(tenant, language, customerNumber, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerV2Api.accountV2TenantLanguageCustomerNumberGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Used by a customer to retrieve the last order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageLastOrderGet(tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV2TenantLanguageLastOrderGet(tenant, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerV2Api.accountV2TenantLanguageLastOrderGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Used by the customer to retrieve all its orders.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageOrdersGet(tenant, language, page, itemsPerPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV2TenantLanguageOrdersGet(tenant, language, page, itemsPerPage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerV2Api.accountV2TenantLanguageOrdersGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Used by a customer to retrieve a single order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {string} orderNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageOrdersOrderNumberGet(tenant, language, orderNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV2TenantLanguageOrdersOrderNumberGet(tenant, language, orderNumber, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerV2Api.accountV2TenantLanguageOrdersOrderNumberGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns customer data including EAV customer and RedPointsMembership.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageUserGet(tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV2TenantLanguageUserGet(tenant, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerV2Api.accountV2TenantLanguageUserGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AccountControllerV2Api - factory interface
 * @export
 */
export const AccountControllerV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountControllerV2ApiFp(configuration);
    return {
        /**
         * Internal API endpoint secured by the PRS Basic Auth Credentials. Fetches customer data (including EAV customers) from the CDS or LMS and returns it. The data is only used by the product-review-service. The call to the CDS is secured by another, different set of Basic Auth credentials.
         * @param {AccountControllerV2ApiAccountV2TenantLanguageCustomerNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageCustomerNumberGet(requestParameters, options) {
            return localVarFp.accountV2TenantLanguageCustomerNumberGet(requestParameters.tenant, requestParameters.language, requestParameters.customerNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by a customer to retrieve the last order.
         * @param {AccountControllerV2ApiAccountV2TenantLanguageLastOrderGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageLastOrderGet(requestParameters, options) {
            return localVarFp.accountV2TenantLanguageLastOrderGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by the customer to retrieve all its orders.
         * @param {AccountControllerV2ApiAccountV2TenantLanguageOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageOrdersGet(requestParameters, options) {
            return localVarFp.accountV2TenantLanguageOrdersGet(requestParameters.tenant, requestParameters.language, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by a customer to retrieve a single order.
         * @param {AccountControllerV2ApiAccountV2TenantLanguageOrdersOrderNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageOrdersOrderNumberGet(requestParameters, options) {
            return localVarFp.accountV2TenantLanguageOrdersOrderNumberGet(requestParameters.tenant, requestParameters.language, requestParameters.orderNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns customer data including EAV customer and RedPointsMembership.
         * @param {AccountControllerV2ApiAccountV2TenantLanguageUserGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2TenantLanguageUserGet(requestParameters, options) {
            return localVarFp.accountV2TenantLanguageUserGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountControllerV2Api - object-oriented interface
 * @export
 * @class AccountControllerV2Api
 * @extends {BaseAPI}
 */
export class AccountControllerV2Api extends BaseAPI {
    /**
     * Internal API endpoint secured by the PRS Basic Auth Credentials. Fetches customer data (including EAV customers) from the CDS or LMS and returns it. The data is only used by the product-review-service. The call to the CDS is secured by another, different set of Basic Auth credentials.
     * @param {AccountControllerV2ApiAccountV2TenantLanguageCustomerNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerV2Api
     */
    accountV2TenantLanguageCustomerNumberGet(requestParameters, options) {
        return AccountControllerV2ApiFp(this.configuration).accountV2TenantLanguageCustomerNumberGet(requestParameters.tenant, requestParameters.language, requestParameters.customerNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Used by a customer to retrieve the last order.
     * @param {AccountControllerV2ApiAccountV2TenantLanguageLastOrderGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerV2Api
     */
    accountV2TenantLanguageLastOrderGet(requestParameters, options) {
        return AccountControllerV2ApiFp(this.configuration).accountV2TenantLanguageLastOrderGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Used by the customer to retrieve all its orders.
     * @param {AccountControllerV2ApiAccountV2TenantLanguageOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerV2Api
     */
    accountV2TenantLanguageOrdersGet(requestParameters, options) {
        return AccountControllerV2ApiFp(this.configuration).accountV2TenantLanguageOrdersGet(requestParameters.tenant, requestParameters.language, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Used by a customer to retrieve a single order.
     * @param {AccountControllerV2ApiAccountV2TenantLanguageOrdersOrderNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerV2Api
     */
    accountV2TenantLanguageOrdersOrderNumberGet(requestParameters, options) {
        return AccountControllerV2ApiFp(this.configuration).accountV2TenantLanguageOrdersOrderNumberGet(requestParameters.tenant, requestParameters.language, requestParameters.orderNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns customer data including EAV customer and RedPointsMembership.
     * @param {AccountControllerV2ApiAccountV2TenantLanguageUserGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerV2Api
     */
    accountV2TenantLanguageUserGet(requestParameters, options) {
        return AccountControllerV2ApiFp(this.configuration).accountV2TenantLanguageUserGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
}
